import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import Promise from 'bluebird'
import { MEDIA_CATEGORIES } from '@/utils/constants'
import store from '@/store'
import { isEmpty, head, last, concat, toNumber, get } from 'lodash'
import helpers from './helpers'
import { errorHandler } from '@/utils/helpers'

const actions = {
    retrieveItems({ commit, rootState, rootGetters }) {
        const linkedAccounts = get(rootState, 'account.linkedAccounts', {})
        if (isEmpty(linkedAccounts) || !rootGetters['account/getAccessToBuilderSegment']()) return

        commit('setIsLoading', true)
        const wcmAccountId = rootState.account.linkedAccounts.wcm.accountId
        const _route = helpers.buildRoutes(rootState.account.accountId)
        Promise.all([
            webRequestClient.get(_route.conversionRoute, _route.conversionParams).catch(() => {
                throw 'Error while retrieving media conversions'
            }),
            webRequestClient.get(_route.campaignRoute, _route.campaignParams).catch(() => {
                throw 'Error while retrieving media campaigns'
            })
        ])
            .then(responses => {
                if (get(responses, 'status', '') === 'KO') {
                    errorHandler('Error while retrieving media', commit)
                } else if (!isEmpty(responses) && (!isEmpty(responses[0].list) || !isEmpty(responses[1].project))) {
                    const _conversions = head(responses)
                    const _campaigns = last(responses)

                    const campaignCategories = [
                        {
                            label: 'Clicked',
                            id: [toNumber(wcmAccountId)],
                            display_order: 1,
                            hasChild: true,
                            isSelectable: true,
                            parentJsonKeyName: 'media_campaign',
                            jsonKey: {
                                ids: [toNumber(wcmAccountId)],
                                name: 'wcm_click_' + wcmAccountId,
                                type: 'WcmClick',
                                subType: 'media_media_campain_clicked'
                            }
                        },
                        {
                            label: 'Exposed',
                            id: [toNumber(wcmAccountId)],
                            display_order: 2,
                            hasChild: true,
                            isSelectable: true,
                            parentJsonKeyName: 'media_campaign',
                            jsonKey: {
                                ids: [toNumber(wcmAccountId)],
                                name: 'wcm_impression_' + wcmAccountId,
                                type: 'WcmImpression',
                                subType: 'media_media_campain_exposed'
                            }
                        }
                    ]
                    commit('setRetrievedItems', {
                        items: concat(
                            MEDIA_CATEGORIES,
                            campaignCategories,
                            helpers.parseConversionData(_conversions.list, wcmAccountId),
                            helpers.parseCampaignData(_campaigns.project, wcmAccountId)
                        )
                    })
                    commit(
                        'setCollection',
                        helpers.instanciateAll(
                            !isEmpty(_conversions.list) ? _conversions.list : [],
                            !isEmpty(_campaigns.project) ? _campaigns.project : {},
                            wcmAccountId
                        )
                    )
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
